<template>
  <div class="about">
    <h1>Unauthorized</h1>
    <p>
      This page is not accessible to you.
    </p>
  </div>
</template>

<script>
export default {
  name: 'Unauthorized',
};
</script>

<style scoped>
.about {
  padding: 2rem;
}
</style>
